export default {"src":"/_next/static/media/coco-copy.8a7de758.svg","height":49,"width":66,"blurWidth":0,"blurHeight":0};